/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { GaugeChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import createMarkup from 'helpers/createMarkup';
import classNames from 'classnames';
import { get } from 'lodash';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  GaugeChart,
  CanvasRenderer,
  LegendComponent
]);

const getOptions = data => ({
  series: [
    {
      type: 'gauge',
      startAngle: 90,
      endAngle: -270,
      radius: '90%',
      pointer: {
        show: false
      },
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: false,
        itemStyle: {
          color: '#469541'
        }
      },
      axisLine: {
        lineStyle: {
          width: 18,
          color: [[1, getColor('gray-200')]]
        }
      },
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        show: false
      },
      data: [
        {
          value: data,
          detail: {
            offsetCenter: ['7%', '4%']
          }
        }
      ],
      detail: {
        width: 50,
        height: 24,
        fontSize: 30,
        fontWeight: 500,
        fontFamily: 'poppins',
        color: getColor('gray-500'),
        formatter: '{value}%'
      }
    }
  ]
});

const BillingHeader = ({ insights, title }) => {
  const insightsValue = get(insights, 'value', 0);
  return (
    <Card className="h-100">
      <FalconCardHeader title="Overall Insights" titleTag="h5" light={true} />
      <Card.Body className="z-index-1 d-flex flex-column justify-content-around">
        <ReactEChartsCore
          echarts={echarts}
          option={getOptions(insightsValue)}
          style={{ height: '15rem' }}
        />
        <div className="text-left">
          {insights && (
            <p
              className={classNames('my-0 insights-text')}
              dangerouslySetInnerHTML={createMarkup(insights.info)}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default BillingHeader;
